var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarCopilotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0039 5.8968C20.3796 5.8968 17.2295 8.06433 15.8535 11.2292H32.1547C30.7785 8.06421 27.6283 5.8968 24.0043 5.8968H24.0039Z",
    fill: "#65FFCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1001 1.46437L24.8776 1.44374L24.9076 4.10998L23.1301 4.13061L23.1001 1.46437Z",
    fill: "#65FFCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5601 3.69936L18.0901 2.79372L19.4494 5.08872L17.9194 5.99436L16.5601 3.69936Z",
    fill: "#65FFCD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0127 8.90841L12.8846 7.35965L15.2096 8.66841L14.3377 10.2172L12.0127 8.90841Z",
    fill: "#65FFCD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7954 8.7L35.0904 7.34064L35.9961 8.87064L33.701 10.23L32.7954 8.7Z",
    fill: "#65FFCD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5747 5.12081L29.8816 2.79581L31.4303 3.66769L30.1235 5.99269L28.5747 5.12081Z",
    fill: "#65FFCD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 12.6667H28.6665L26.6665 18.6667H16.6665L18.6665 12.6667Z",
    fill: "#673898"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20H26L24 26H14L16 20Z",
    fill: "#673898"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 27.3333H23.3335L21.3335 33.3333H11.3335L13.3335 27.3333Z",
    fill: "#673898"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.6667H40L38 18.6667H28L30 12.6667Z",
    fill: "#673898"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3335 20H37.3335L35.3335 26H25.3335L27.3335 20Z",
    fill: "#673898"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6665 27.3333H34.6665L32.6665 33.3333H22.6665L24.6665 27.3333Z",
    fill: "#673898"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 12.6667H17.3335L15.3335 18.6667H5.3335L7.3335 12.6667Z",
    fill: "#673898"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 20H14.6665L12.6665 26H2.6665L4.6665 20Z",
    fill: "#673898"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27.3333H12L10 33.3333H0L2 27.3333Z",
    fill: "#673898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarCopilotIcon);
export default __webpack_public_path__ + "static/media/SolarCopilotIcon.163437a148a18fe7ce66a852d28ea9e2.svg";
export { ForwardRef as ReactComponent };